<template>
  <v-card>
    <v-toolbar flat color="primary">
      <span class="headline">Deny</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="notes-text">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <v-textarea textarea hide-details label="Notes" v-model="notes">
            </v-textarea>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-form>
    </v-card-text>
    <div class="pl-5" style="font-size: 18px">
      Description
    </div>
<v-layout row class="withdrawn-reason-container">
  <!-- Left Side: Radio Buttons -->
  <v-flex class="radio-container">
    <v-radio-group v-model="withdrawnCode">
      <div class="radio-flex-container">
        <v-radio
          v-for="(option, j) in WithdrawnReason.positive"
          color="primary"
          :label="option.text"
          :value="option"
          :key="'positive-' + j"
          class="reason-text"
        >
          <!-- Tooltip for reasons -->
          <template v-slot:label>
            <span>{{ option.text }}</span>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="grey"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  size="20"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <!-- Tooltip Content -->
              <div v-if="getReasons(option.value).length > 0" style="white-space: normal; max-width: 600px;">
                <ul style="padding: 0; margin: 0; list-style-type: none;">
                  <li v-for="(reason, index) in getReasons(option.value)" :key="index">
                    {{ reason }}
                  </li>
                </ul>
              </div>
              <span v-else>No additional information</span>
            </v-tooltip>
          </template>
        </v-radio>
      </div>
      <div class="radio-flex-container">
        <v-radio
          v-for="(option, i) in WithdrawnReason.negative"
          color="primary"
          :label="option.text"
          :value="option"
          :key="'negative-' + i"
          class="reason-text"
        >
          <!-- Tooltip for reasons -->
          <template v-slot:label>
            <span style="word-wrap: break-word; white-space: normal;">{{ option.text }}</span>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="grey"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  size="20"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <!-- Tooltip Content -->
              <div v-if="getReasons(option.value).length > 0" style="white-space: normal;">
                <ul style="padding: 0; margin: 0; list-style-type: none;">
                  <li v-for="(reason, index) in getReasons(option.value)" :key="index">
                    {{ reason }}
                  </li>
                </ul>
              </div>
            </v-tooltip>
          </template>
        </v-radio>
      </div>
    </v-radio-group>
  </v-flex>
</v-layout>
        <v-card-actions class="pb-3">
      <v-btn class="save-button" v-if="showApprovalFormButton()" color="blue darken-1" text @click="showDialog">Approval Form</v-btn>
      <v-spacer></v-spacer>
      <v-btn class="save-button" color="blue darken-1" text @click="saveNote">Save</v-btn>
    </v-card-actions>
    <template>
</template>
    <v-dialog v-model="approvalFormDialog.display" max-width="1000px" persistent>
      <approval-form-dialog
        :actionType="approvalFormDialog.actionType"
        @hideDialog="hideApprovalFrom"
        @saveUnderwriterApproval="saveUnderwriterApproval"
      ></approval-form-dialog>
    </v-dialog>
  </v-card>
</template>

<script>
import { Tool, DataType } from '@/util/index'
import ApprovalFormDialog from './ApprovalFormDialog'
import { OriginationBusinessApi } from '@/api/pandaria'
const tool = new Tool()

export default {
  name: 'deny-dialog',
  components: {
    ApprovalFormDialog
  },
  props: {
    loan: Object
  },
  data () {
    return {
      valid: true,
      notes: '',
      status: DataType.LoanStatus,
      WithdrawnReason: {
        positive: [],
        negative: []
      },
      WithdrawnReasonEnum: [],
      withdrawnCode: null,
      tool: tool,
      approvalFormDialog: {
        display: false,
        actionType: null,
        data: {}
      },
      denyCode: '',
      noaaReasonValue: '',
      noaaReasonEnum: [],
      legacyReasons: DataType.LegacyReasons,
      setDenyCode: ''
    }
  },
  mounted () {
    this.getWithReasonData()
    this.getDenyReasonData()
  },
  methods: {
    getReasons (denyCode) {
      const matchedReason = this.legacyReasons.find(item => item.value === Number(denyCode))
      return matchedReason ? matchedReason.text : []
    },
    saveNote () {
      if (tool.isEmpty(this.notes)) {
        this.$swal({ type: 'warning', text: 'Please add note content', showCancelButton: false })
      } else if (tool.isEmpty(this.withdrawnCode)) {
        this.$swal({ type: 'warning', text: 'Please select the reason of deny', showCancelButton: false })
      } else {
        const targetStatus = this.status.TRIBE_NOAA_REVIEW.value
        const reasonCode = this.withdrawnCode.value
        this.denyCode = this.withdrawnCode.denyCode
        const updateStatusData = { targetStatus: targetStatus, note: this.notes, reasonCode: reasonCode, denyCode: this.denyCode }
        if (tool.isNotEmpty(this.approvalFormDialog.data)) {
          updateStatusData.underwriterApproval = this.approvalFormDialog.data
        }
        this.$emit('updateLoanStatusAndAddNote', updateStatusData)
        this.hideDialog()
        this.notes = ''
        this.store.commit('setSendEmailLoanId', '')
      }
    },
    showApprovalFormButton () {
      return this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value
    },
    showDialog () {
      this.approvalFormDialog.actionType = '24002'
      this.approvalFormDialog.display = true
    },
    hideApprovalFrom () {
      this.approvalFormDialog.display = false
    },
    saveUnderwriterApproval (data) {
      this.approvalFormDialog.display = false
      this.approvalFormDialog.data = data
    },
    hideDialog () {
      this.$emit('hideDialog', 'DENY')
    },
    getDenyReasonData () {
      this.noaaReasonEnum = []
      const $this = this
      OriginationBusinessApi.getDenyReasonData({ code: 'DENY_REASON' }, function (result) {
        $this.noaaReasonEnum = result
      })
    },
    // getLegacyReasons () {
    //   this.legacyReasons = []
    // },
    noaaReason (denyCode) {
      this.noaaReasonValue = ''
      this.setDenyCode = JSON.parse(denyCode)
      if (tool.isNotEmpty(this.noaaReasonEnum)) {
        this.noaaReasonEnum.map(item => {
          if (tool.isNotEmpty(item.code) && tool.isNotEmpty(this.setDenyCode)) {
            if (this.setDenyCode.includes(item.code)) {
              if (this.setDenyCode.length === 1) {
                this.noaaReasonValue = item.text
              } else {
                if (this.noaaReasonValue === '') {
                  this.noaaReasonValue = `${item.text}`
                } else {
                  this.noaaReasonValue = `${item.text} / ${this.noaaReasonValue}`
                }
              }
            }
          } else {
            this.noaaReasonValue = ''
          }
        })
      } else {
        this.noaaReasonValue = ''
      }
    },
    getWithReasonData () {
      const $this = this
      $this.WithdrawnReasonEnum = []
      OriginationBusinessApi.getWithReasonData(function (result) {
        $this.WithdrawnReasonEnum = result.POSITIVE.concat(result.NEGATIVE)
        $this.WithdrawnReason.positive = result.POSITIVE
        $this.WithdrawnReason.negative = result.NEGATIVE
      })
    }
  }
}
</script>
<style lang="css" scoped>
  .notes-text {
    margin-top: 10px;
  }
  .radio-flex-container {
  display: flex;
  flex-wrap: wrap; /* Allows radio buttons to wrap into multiple rows */
  gap: 20px; /* Space between radio buttons */
  max-height: 480px;  /*Limit height to enable scrollbar when overflowing*/
  overflow-y: auto; /* Scroll only when needed */
  align-items: center;
  font-size: medium;
  color: black;
  /* width: 100%; */
}
.reason-text {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 80%;
  margin-bottom: 10px; /* Ensures text stays in a single line */
}
.radio-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
  .save-button {
    margin-top: 15px;
  }
  .v-input--selection-controls.v-input {
    flex: 1;
  }
.withdrawn-reason-container {
  margin: 0 5px 15px 25px;
  width: 1260px;
  height: 480px;
  display: flex; /* Arrange elements in a row */
  gap: 20px; /* Add space between radio and reason text */
  align-items: flex-start; /* Align to the top */
}
</style>
